import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import { Icon, Input, Tooltip } from 'antd';

import './styles.css';
import money from '../../helpers/money';

const numericOnlyRegex = /^(0|[1-9][0-9]*)?$/;

const formatNumber = (inputNumber) => {
  const thousands = 3;
  const digits = inputNumber.split('.');
  const numbPrefix = (digits[0].charAt(0) === '-') ? '-' : '';
  let numricValue = (numbPrefix) ? digits[0].slice(1) : digits[0];
  let unformattedNumber = '';
  while (numricValue.length > thousands) {
    unformattedNumber = `,${numricValue.slice(-thousands)}${unformattedNumber}`;
    numricValue = numricValue.slice(0, numricValue.length - 3);
  }
  if (numricValue) { unformattedNumber = numricValue + unformattedNumber; }
  const formattedNumber = `${numbPrefix}${unformattedNumber}${(digits[1]) ? `.${digits[1]}` : ''}`;
  return formattedNumber;
};

const NumericInput = React.forwardRef(({ numericonly, currency, showprefix, showtooltip, tooltiptitle, value, onChange, onBlur, ...props }, ref) => { // eslint-disable-line no-unused-vars
  const numericInputReference = useRef(null);
  const [customPrefix, setCustomPrefix] = useState(null);
  const [lastValue, setLastValue] = useState('');

  useEffect(() => {
    if (!showprefix) { return; }
    setCustomPrefix(
      (currency) ? (
        <span className="currency-prefix" style={{ color: 'rgba(0,0,0,.25)' }}>
          {currency}
        </span>
      ) : (
        <Icon type="dollar" style={{ color: 'rgba(0,0,0,.25)' }} />
      ),
    );
  }, [currency, showprefix]);

  const handleOnChange = (event) => {
    const { value: eventValue } = event.target;
    const formattingRegex = (numericonly) ? numericOnlyRegex : money.getNumberRegex(currency);
    if (!((!Number.isNaN(eventValue) && formattingRegex.test(eventValue)) || eventValue === '')) { return; }
    numericInputReference.current.value = eventValue;
    setLastValue(eventValue);
    if (onChange) { onChange(eventValue); }
  };

  const handleOnBlur = () => {
    const inputValue = value;
    if (!inputValue) { return; }
    if ((inputValue.charAt(inputValue.length - 1) === '.' || inputValue === '-') && onChange) {
      onChange(inputValue.slice(0, -1));
    }
    if (onBlur) { onBlur(); }
  };
  const getTitle = () => {
    let title = (tooltiptitle || 'Input a number');
    if (value) { title = <span className="numeric-input-title"> {(value !== '-') ? formatNumber(value) : '-'}</span>; }
    return title;
  };
  if (showtooltip) {
    return (
      <Tooltip trigger={['focus']} title={getTitle()} placement="topLeft" overlayClassName="numeric-input">
        <Input {...props} onChange={handleOnChange} onBlur={handleOnBlur} maxLength={25} prefix={customPrefix} ref={numericInputReference} value={lastValue} />
      </Tooltip>
    );
  }
  return <Input {...props} onChange={handleOnChange} onBlur={handleOnBlur} maxLength={25} prefix={customPrefix} ref={numericInputReference} value={lastValue} />;
});

NumericInput.propTypes = {
  currency: PropTypes.string,
  numericonly: PropTypes.bool,
  showprefix: PropTypes.bool,
  showtooltip: PropTypes.bool,
  tooltiptitle: PropTypes.string,
  value: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};

export default NumericInput;
